import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Parse "14. 4. 2026" -> Date
const parseUpdated = (s) => {
  if (!s) return null;
  const m = String(s).match(/(\d{1,2})\.\s*(\d{1,2})\.\s*(\d{4})/);
  if (!m) return null;
  return new Date(Number(m[3]), Number(m[2]) - 1, Number(m[1]));
};

const MONTHS = {
  cs: [
    "leden", "únor", "březen", "duben", "květen", "červen",
    "červenec", "srpen", "září", "říjen", "listopad", "prosinec",
  ],
  uk: [
    "січень", "лютий", "березень", "квітень", "травень", "червень",
    "липень", "серпень", "вересень", "жовтень", "листопад", "грудень",
  ],
  en: [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December",
  ],
};

export const formatUpdatedLabel = (updatedStr, lang) => {
  const d = parseUpdated(updatedStr);
  if (!d) return null;
  const months = MONTHS[lang] || MONTHS.cs;
  return `${months[d.getMonth()]} ${d.getFullYear()}`;
};

export const formatRate = (n) =>
  Number(n).toFixed(2).replace(".", ",") + " %";

// Always fetches fresh on every mount so admin updates propagate to open tabs.
export const useRates = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    axios
      .get(`${API}/rates/current`, { timeout: 8000 })
      .then((r) => {
        if (alive) {
          setData(r.data);
          setLoading(false);
        }
      })
      .catch(() => {
        if (alive) setLoading(false);
      });
    return () => {
      alive = false;
    };
  }, []);

  return { data, loading };
};
